













import { Component, Prop, Vue } from 'vue-property-decorator';
import General from '@/components/settings/General.vue';
import Metadata from '@/components/metadata/Metadata.vue';

@Component({
  components: {
    General,
    Metadata
  },
})
export default class Settings extends Vue {
  private activeTab: number = 0;


}
